import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s8/b2.jpg');

class Services_8 extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Eyes on Duty. Coverage You Can Count On."
            pagename="CCTV Surveillance"
            bgimage={bnrimg}
          />

          <div className="section-full p-tb80 inner-page-padding">
            <div className="container">
              <div className="blog-single-wrap-width">
                <div className="blog-post date-style-3 blog-detail text-black">
                  <div className="mt-post-media clearfix m-b30">
                    <ul className="grid-post">
                      <li>
                        <div className="portfolio-item">
                          <img
                            className="img-responsive"
                            src={require("./../../images/s8/b1.jpg")}
                            alt="CCTV Surveillance"
                          />
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="mt-post-title">
                    <h3 className="post-title font-weight-600">CCTV Surveillance</h3>
                  </div>

                  <div className="mt-post-text">
                    <p><strong>"When vigilance is your shield, no threat goes unseen."</strong></p>

                    <p>
                      At <strong>I‑Smart Engineering Works</strong>, we deliver rugged, high-definition CCTV surveillance systems designed for mission-critical operations. Whether you're protecting a facility, campus, or perimeter, our systems maintain a silent watch—vigilant, precise, and always alert.
                    </p>

                    <p>
                      Built with military-level robustness, our CCTV installations feature night vision, motion detection, remote monitoring, and secure recording—ensuring you stay ahead of risk even in the toughest environments.
                    </p>

                    <h4 className="font-weight-600">Our CCTV Services Include:</h4>
                    <ul className="list-angle-right">
                      <li>HD & IR-capable camera planning and installation</li>
                      <li>360° pan-tilt-zoom (PTZ) surveillance cameras</li>
                      <li>Networked recording, storage, and analytics</li>
                      <li>Remote monitoring via mobile & web dashboards</li>
                      <li>Integration with access control & alarm systems</li>
                      <li>AMC for system health checks and performance tuning</li>
                    </ul>

                    <blockquote className="bg-dark text-white author-quote">
                      <h4 className="m-b0">
                        “We trust the watch to safeguard our ships—your site deserves the same relentless gaze.” <i className="fa fa-quote-right" />
                      </h4>
                      <div className="p-t15 text-white">
                        <strong className="text-primary">Senior Chief L. Morgan</strong>
                        <span>U.S. Navy Security Operations</span>
                      </div>
                    </blockquote>

                    <p>
                      Our surveillance systems are built for zero blind spots—providing you actionable intelligence and real-time alerts. Equip your facility with CCTV that operates as diligently as your team.
                    </p>

                    {/* <div className="row">
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog.jpg")} alt="CCTV Setup" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog2.jpg")} alt="PTZ Camera" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 col-sm-4">
                        <div className="mt-box m-b30">
                          <div className="mt-media">
                            <img src={require("./../../images/blog/large-blog3.jpg")} alt="Remote Monitoring" />
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <p>
                      <strong>Ready to deploy surveillance that never sleeps?</strong> Contact us for a CCTV audit and turnkey installation blueprint.
                    </p>
                  </div>

                  <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                    <div className="row">
                      <div className="col-md-6 col-sm-6">
                        <div className="widget widget_tag_cloud">
                          <h4 className="tagcloud">Tags</h4>
                          <div className="tagcloud">
                            <NavLink to="#">CCTV</NavLink>&nbsp;
                            <NavLink to="#">Surveillance</NavLink>&nbsp;
                            <NavLink to="#">Security Camera</NavLink>&nbsp;
                            <NavLink to="#">Remote Monitoring</NavLink>&nbsp;
                            <NavLink to="#">AMC Surveillance</NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default Services_8;
